import * as React from 'react'

export const SuccessSvg: React.FCC = () => (
  <svg
    width="140"
    height="84"
    viewBox="0 0 140 84"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="28" width="80" height="80" rx="16" fill="white" />
    <path
      d="M80.85 39.975L63.075 55.8V26.55L56.775 29.8507V61.575L60.75 64.8L90 38.55L60.3 15L54 18.3L80.85 39.975Z"
      fill="#1BC47D"
    />
    <rect x="78" y="52" width="60" height="30" rx="15" fill="white" />
    <path
      d="M99.5 63.5003L92.5 70.5L89 67.0003"
      stroke="#1BC47D"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M105.367 71.5V62.7727H108.81C109.472 62.7727 110.036 62.8991 110.502 63.152C110.968 63.402 111.323 63.75 111.568 64.196C111.815 64.6392 111.938 65.1506 111.938 65.7301C111.938 66.3097 111.813 66.821 111.563 67.2642C111.313 67.7074 110.951 68.0526 110.477 68.2997C110.005 68.5469 109.434 68.6705 108.764 68.6705H106.569V67.1918H108.465C108.82 67.1918 109.113 67.1307 109.343 67.0085C109.576 66.8835 109.749 66.7116 109.863 66.4929C109.979 66.2713 110.038 66.017 110.038 65.7301C110.038 65.4403 109.979 65.1875 109.863 64.9716C109.749 64.7528 109.576 64.5838 109.343 64.4645C109.11 64.3423 108.815 64.2812 108.457 64.2812H107.212V71.5H105.367ZM113.257 71.5V62.7727H116.7C117.359 62.7727 117.922 62.8906 118.387 63.1264C118.856 63.3594 119.213 63.6903 119.457 64.1193C119.704 64.5455 119.828 65.0469 119.828 65.6236C119.828 66.2031 119.703 66.7017 119.453 67.1193C119.203 67.5341 118.841 67.8523 118.366 68.0739C117.895 68.2955 117.324 68.4062 116.653 68.4062H114.348V66.9233H116.355C116.707 66.9233 117 66.875 117.233 66.7784C117.466 66.6818 117.639 66.5369 117.753 66.3438C117.869 66.1506 117.927 65.9105 117.927 65.6236C117.927 65.3338 117.869 65.0895 117.753 64.8906C117.639 64.6918 117.464 64.5412 117.228 64.4389C116.995 64.3338 116.701 64.2812 116.346 64.2812H115.102V71.5H113.257ZM117.97 67.5284L120.139 71.5H118.102L115.98 67.5284H117.97ZM129.272 67.1364C129.272 68.0881 129.091 68.8977 128.73 69.5653C128.373 70.233 127.884 70.7429 127.265 71.0952C126.648 71.4446 125.955 71.6193 125.185 71.6193C124.409 71.6193 123.713 71.4432 123.097 71.0909C122.48 70.7386 121.993 70.2287 121.635 69.5611C121.277 68.8935 121.098 68.0852 121.098 67.1364C121.098 66.1847 121.277 65.375 121.635 64.7074C121.993 64.0398 122.48 63.5312 123.097 63.1818C123.713 62.8295 124.409 62.6534 125.185 62.6534C125.955 62.6534 126.648 62.8295 127.265 63.1818C127.884 63.5312 128.373 64.0398 128.73 64.7074C129.091 65.375 129.272 66.1847 129.272 67.1364ZM127.401 67.1364C127.401 66.5199 127.309 66 127.124 65.5767C126.942 65.1534 126.685 64.8324 126.353 64.6136C126.02 64.3949 125.631 64.2855 125.185 64.2855C124.739 64.2855 124.35 64.3949 124.017 64.6136C123.685 64.8324 123.427 65.1534 123.242 65.5767C123.06 66 122.969 66.5199 122.969 67.1364C122.969 67.7528 123.06 68.2727 123.242 68.696C123.427 69.1193 123.685 69.4403 124.017 69.6591C124.35 69.8778 124.739 69.9872 125.185 69.9872C125.631 69.9872 126.02 69.8778 126.353 69.6591C126.685 69.4403 126.942 69.1193 127.124 68.696C127.309 68.2727 127.401 67.7528 127.401 67.1364Z"
      fill="#1BC47D"
    />
    <rect
      x="78"
      y="52"
      width="60"
      height="30"
      rx="15"
      stroke="#1BC47D"
      strokeWidth="4"
    />
  </svg>
)

interface IProps {}
export const Success: React.FCC<IProps> = ({}) => {
  return (
    <div className="bg-green rounded-[10px] flex flex-col items-center text-white text-center py-[40px] px-[20px] w-[360px]">
      <SuccessSvg />

      <h2 className="font-header mt-[40px] font-header text-[28px] leading-[36px] font-semibold">
        Success!
      </h2>

      <p className="font-body text-[20px] font-description leading-[30px] font-normal mt-[16px]">
        Welcome to the PRO club! <br />
        You have unlocked a bunch of exciting features. <br />
        <span className="block my-[10px]" />
        Thank you for your support! You are awesome :)
      </p>
    </div>
  )
}
